import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, normalizeClass as _normalizeClass, vShow as _vShow, withDirectives as _withDirectives, TransitionGroup as _TransitionGroup } from "vue"

const _hoisted_1 = { key: "almbrandCustomer" }
const _hoisted_2 = {
  class: "pb-3 text-left",
  key: "almbrandCustomerLabel"
}
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", null, "Har du forsikringer hos Alm. Brand?", -1)
const _hoisted_4 = {
  key: 0,
  class: "text-left"
}
const _hoisted_5 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Vælg ja eller nej'
}, null, -1)
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = { key: "almbrandProducts" }
const _hoisted_8 = ["textContent"]
const _hoisted_9 = ["innerHTML"]
const _hoisted_10 = {
  key: 0,
  class: "text-left mt-1"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("span", {
  class: "input__field--error_message input__field--error_message--selects",
  textContent: 'Du mangler at angive forsikringer'
}, null, -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: "pluscustomer_info_box",
  class: "highlights fill mb-4 mt-3"
}
const _hoisted_14 = { class: "text-left" }
const _hoisted_15 = ["innerHTML"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PopoverComponent = _resolveComponent("PopoverComponent")!
  const _component_RadioComponent = _resolveComponent("RadioComponent")!
  const _component_checkboxComponent = _resolveComponent("checkboxComponent")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        (_ctx.cms.plusCustomerPopover)
          ? (_openBlock(), _createBlock(_component_PopoverComponent, {
              key: 0,
              type: "icon",
              buttonClass: "popover__icon popover__icon__questionmark",
              class: "page-component__popover text-left",
              innerData: _ctx.cms.plusCustomerPopover
            }, null, 8, ["innerData"]))
          : _createCommentVNode("", true)
      ]),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.jaNejArray, (item, inx) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass([inx + 1 === _ctx.jaNejArray.length ? 'pb-3' : 'pb-2']),
          key: 'almbrandCustomer' + inx
        }, [
          _createVNode(_component_RadioComponent, {
            name: "almbrandCustomer",
            id: 'almbrandCustomer' + item.value,
            inputValue: item.value,
            preSelect: _ctx.model.personInfo.almbrandCustomer,
            change: _ctx.model.personInfo.almbrandCustomer === item.value,
            trackingLabel: 'Almbrand kunde' + item.value,
            onRadioComponent: _ctx.radioEvent
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.displayValue), 1)
            ]),
            _: 2
          }, 1032, ["id", "inputValue", "preSelect", "change", "trackingLabel", "onRadioComponent"])
        ], 2))
      }), 128)),
      (_ctx.customerErr)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, _hoisted_6))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_TransitionGroup, { name: "slide-vertical-no-delay" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", {
            class: "pb-3 text-left",
            textContent: _toDisplayString('Vælg hvilke(n) af disse forsikringer du har i dag?')
          }, null, 8, _hoisted_8),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.discountProductsFiltered, (item, inx) => {
            return (_openBlock(), _createElementBlock("div", {
              key: 'existingAlmBrandProducts' + inx
            }, [
              (_openBlock(), _createBlock(_component_checkboxComponent, {
                key: '' + inx + _ctx.updateKeys.get(item),
                id: item,
                name: item,
                preSelect: _ctx.model.personInfo.existingAlmBrandProducts.includes(item),
                inputValue: item,
                class: "pb-2",
                visibleError: false,
                onCheckboxComponent: _ctx.checkboxEvent
              }, {
                default: _withCtx(() => [
                  _createElementVNode("span", {
                    class: "text-left",
                    innerHTML: item
                  }, null, 8, _hoisted_9)
                ]),
                _: 2
              }, 1032, ["id", "name", "preSelect", "inputValue", "onCheckboxComponent"]))
            ]))
          }), 128)),
          (_ctx.errorProducts)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
            : _createCommentVNode("", true)
        ], 512), [
          [_vShow, _ctx.model.personInfo.almbrandCustomer === 'ja' && _ctx.discountProductsFiltered.length > 1]
        ]),
        _withDirectives(_createElementVNode("div", _hoisted_13, [
          _createElementVNode("div", _hoisted_14, [
            _createElementVNode("span", { innerHTML: _ctx.plusCustomerInfo }, null, 8, _hoisted_15)
          ])
        ], 512), [
          [_vShow, _ctx.cms.plusCustomerNoDiscount]
        ])
      ]),
      _: 1
    })
  ]))
}